/* eslint key-spacing: 'off', comma-spacing: 'off', prefer-const: 'off', eqeqeq: 'off', no-unneeded-ternary: 'off' */
import commonModelHelper from '@/scripts/commonModelHelper';
import current from '@/scripts/current';
import VariableSelection from '@/bo/VariableSelection';
import VariableGroup from '@/bo/VariableGroup';
import store from '@/store';
import variableDataAccess from '@/scripts/variableDataAccess';
import metricsHelper from '@/scripts/metricsHelper';
import common from '@/scripts/common';
import $ from 'jquery';


function initializeStep(vm, currentStep) {
    store.dispatch('display/setIsLoading', false);
    //var test = metricsHelper.generateUUID();

    var stepIndex = current.navigation.stepIndex[currentStep];
    var previousStep = current.navigation.keys[stepIndex - 1];
    current.testHelper.setTestValues(previousStep, vm.$route);
    let isModelComplete = current.modelHelper.modelIsComplete(current.selectionModel, previousStep);
    if (!isModelComplete) {
        if (process.env.NODE_ENV && process.env.NODE_ENV === 'development')
            console.log('Model is not complete for step ' + currentStep);
        vm.$router.push({ path: current.navigation.getPage(stepIndex, stepIndex - 1) });
    }

    current.selectionModel.currentStep = currentStep;
    current.modelHelper.resetValuesForCurrentStep(currentStep);
    var currentStepIndex = current.navigation.stepIndex[currentStep];
    var pageKeys = current.navigation.keys.slice(1).filter((k, i) => { return i < currentStepIndex });
    var breadCrumbs = pageKeys.map(k => ({ name: current.navigation.routeNames[k], url: current.navigation.page[k], title: current.navigation.titles[k] }));
    store.dispatch('display/setBreadCrumbs', breadCrumbs);
    store.dispatch('display/setMenu', { menuGroup: 'analysis', menuItem: current.navigation.type });
    //The root key is WEAT itself, so skip it
    /*Vue.set(current.breadCrumbLinks, current.navigation.keys.slice(1).map(k => ({ url: current.navigation.page[k], title: current.navigation.titles[k] })));*/
    return isModelComplete;
}



export default {
    // getNumberOfSourceRecords: function (levelId, variableType) {
    //   let yearLevelId = variableType === 'year' ? levelId : 0;
    //   let locationLevelId = variableType === 'location' ? levelId : 0;
    //   return store.state.report.deprecatedCountsByYearState[yearLevelId][locationLevelId];
    // },
    getMissingData: function (variables) {
        //console.log('variables', variables);
        const selectedVariables = variables.filter(v => v && v.include);
        let v = current.selectionModel.v;
        let source = store.state.report.numberOfSourceRecords;
        //let variables = [v.row, v.column, v.control1, v.control2, ...v.independent ? v.independent : []];
        // window.selectedVariables = selectedVariables;
        // console.log('selectedVariables', selectedVariables);
        let yearVariable = common.find(selectedVariables, v => v.type === 'year');
        let locationVariable = common.find(selectedVariables, v => v.type === 'location');
        // let missingDataYears = yearVariable ?
        //   yearVariable.Level
        let missingDataYear = common.find(Object.keys(source).filter(y => yearVariable || y == 0), y => {
            let missingDataLocation = common.find(Object.keys(source[y]).filter(l => locationVariable || l == 0), l => {
                return source[y][l] === 0;
            })
            return Boolean(missingDataLocation);
        }
        );
        //let hasMissingData = missingDataYear !== undefined;
        return !missingDataYear ? null : {
            hasMissing: true,
            yearVariable: yearVariable,
            locationVariable: locationVariable
        };
    },
    getNumberOfSourceRecords: function (levelCode, variableType) {
        let surveyYear = variableType === 'year' ? levelCode : 0;
        let fipsCode = variableType === 'location' ? levelCode : 0;
        return store.state.report.numberOfSourceRecords[surveyYear][fipsCode];
    },
    getNumberOfSourceRecordsCt: function (controlLevels, rowLevel, columnLevel) {
        var year = getLevelCodeOfVariable(store.state.report.yearVariable, controlLevels, rowLevel, columnLevel);
        var location = getLevelCodeOfVariable(store.state.report.locationVariable, controlLevels, rowLevel, columnLevel);
        return store.state.report.numberOfSourceRecords[year][location];
    },
    getNumberOfLevels: function (variableSelection) {
        if (!variableSelection || !variableSelection.include)
            return 1;
        if (variableSelection.type === 'year')
            return store.state.selModel.years.values.length;
        if (variableSelection.type === 'location')
            return store.state.selModel.locations.allIds.length;
        var variable = variableDataAccess.getLevelCounts(variableSelection.variable.variable);
        if (!variable)
            return 1;
        return current.selectionModel.selectedStatistics && current.selectionModel.selectedStatistics.nonResponse ? variable.numberOfLevels : variable.numberOfResponseLevels;
    },
    //getAllLocationIds: function () {
    //  var m = current.selectionModel;
    //  if (allStatesSelected() ||
    //    ((m.selectedLocation === -1 || m.selectedLocation === '-1') && m.selectedLocations.length === 0))  //Not selected yet
    //    return 0;
    //  return m.selectedLocations.length > 0 ? m.selectedLocations.map(l => l.stateId)
    //    : [m.selectedLocation.stateId];
    //},
    initializeStep,
    resetYear: function () {
        store.dispatch("selModel/setYearSelectionType", { selectionType: 'single' });
        store.dispatch("selModel/setYears", { selectedYears: [] });
    },
    resetLocation: function () {
        store.dispatch('selModel/setLocations',
            {
                selectionType: 'single',
                locationIds: []
            });
    },
    nullGroup: { variables: [] },
    getResetVariable: function (allowedVariableTypes, lastType, lastGroupId, groupsForVariableSelection) {
        var type = allowedVariableTypes.defaultType === null ? lastType : allowedVariableTypes.defaultType;
        var variable = null;
        if (type === 'location')
            variable = VariableSelection.newLocation().variable;
        if (type === 'year')
            variable = VariableSelection.newYear().variable;
        return new VariableSelection(
      /*variable=*/variable,
      /*type=*/type,
      /*include=*/allowedVariableTypes.isRequired,
      /*group=*/commonModelHelper.resetGroup(allowedVariableTypes.isRequired, type, groupsForVariableSelection, lastType, lastGroupId),
      /*categories=*/null);
    },
    resetGroup: function (isIncluded, selectedType, groupsForVariableSelection, lastType, lastGroupId) {
        //If variable is still selected, reselect the same group,
        if (isIncluded && selectedType === 'variable' && !isNaN(lastGroupId)) {
            var matchingGroups = groupsForVariableSelection.filter(g => g.id === lastGroupId);
            if (matchingGroups.length > 0)
                return matchingGroups[0];
        }
        return new VariableGroup();
    },
    getDisplayYearsWithAnd: function () {
        return toTitleList(store.state.selModel.years.values);
    },
    getSelectedVariables: function (selectionModel, variableTypes) {
        var vm = this;
        var usedVariables = { year: false, location: false };
        for (var i = 0; i < variableTypes.length; i++) {
            var variableType = variableTypes[i];
            switch (selectionModel.v[variableType].type) {
                case 'year':
                    usedVariables.year = true;
                    break;
                case 'location':
                    usedVariables.location = true;
                    break;
                case 'variable':
                    if (selectionModel.v[variableType].variable !== undefined &&
                        selectionModel.v[variableType].variable !== null)
                        usedVariables[selectionModel.v[variableType].variable.variable] = true;
                    break;
            }
        }
        //console.log('getSelectedVariables', selectionModel, variableTypes, usedVariables)
        return usedVariables;
    },
    stateContainsYear: function (stateYears, year) {
        for (var i = 0; i < stateYears.length; ++i) {
            if (stateYears[i].year === year)
                return true;
        }
        return false;
    },
    getDatasetTotalRecords: function (recordTotals) {
        var hasMultipleYears = store.state.selModel.years.values.length > 1;
        var yearLabel = 'year';
        if (hasMultipleYears)
            yearLabel += 's';
        var locationLabel = 'location';
        if (store.state.selModel.locations.allIds.length > 1)
            locationLabel += 's';
        var allTotals = [
            {
                label: 'Number of records on the BRFSS dataset for the ' + yearLabel + ' and location selected',
                total: recordTotals.numberOfRecords,
                annotation: ''
            },
            {
                label: 'Number of records excluded from the analysis',
                total: recordTotals.numberOfRecordsExcluded,
                annotation: ''
            },
            //{
            //  label: 'Sample Size (Number of records used in the analysis)',
            //  total: recordTotals.numberOfRecordsUsed
            //},
            {
                label: 'Sample Size (Number of records used in the analysis)',
                total: recordTotals.n,
                annotation: ''
            }
        ];
        if (!hasMultipleYears)
            allTotals.push({
                label: 'Total Weighted N (Population)',
                total: recordTotals.weightedN,
                annotation: ''
            });
        return allTotals;
    },
    jumpTo: function (e, control, name) {
        var rect = control.$el.getBoundingClientRect();
        //console.log(`Jump to ${name} at ${rect.top}`)
        $([document.documentElement, document.body]).animate({
            scrollTop: rect.top
        }, 500);
        if (e && e.preventDefault)
            e.preventDefault();
        else
            return false;
    },
    jumpToElement: function (e, $el) {
        var rect = $el.getBoundingClientRect();
        $([document.documentElement, document.body]).animate({
            scrollTop: rect.top
        }, 500);
        if (e && e.preventDefault)
            e.preventDefault();
        else
            return false;
    },
    continueToNextPage: function ($router) {
        switch (current.selectionModel.currentStep) {
            case 'years':
                metricsHelper.yearSelected();
                break;
            case 'location':
                metricsHelper.locationSelected();
                break;
        }
        $router.push({ path: current.navigation.getNextPage() });
    },
    getDisplayLocationsWithSelectionType: function (locations) {
        return locations.names.length > 0 ? locations.names.join(', ') + ' (' + locations.selectionType + ')' : '';
    },
    getLocationsForXlsx: function (locations) {
        if (locations.all)
            return 'All locations';
        if (locations.selectionType === 'single')
            return locations.names[0];
        return locations.names.join(', ') + ' (' + locations.selectionType + ')';
    },
    getReportTitleLocations: function (locations) {
        var vm = this;
        if (locations.all)
            return 'All locations';
        if (locations.selectionType === 'single')
            return locations.names[0];
        return 'for ' + toTitleList(locations.names);
    },
    groupLocations,
    //getAllLocationsOld,
    getAllLocationsForSelection
}

function getLevelCodeOfVariable(variableType, controlLevels, rowLevel, columnLevel) {
    let levelId = getLevelCode(variableType, controlLevels, rowLevel, columnLevel);
    return levelId ? levelId : "0";
}

function getLevelCode(variableType, controlLevels, rowLevel, columnLevel) {
    if (!variableType)
        return null;
    if (variableType === 'row')
        return rowLevel && rowLevel.code != 0 ? rowLevel.code : null;
    if (variableType === 'column')
        return columnLevel && columnLevel.code != 0 ? columnLevel.code : null;
    else
        return controlLevels && controlLevels[variableType] && controlLevels[variableType].code != 0 ? controlLevels[variableType].code : null;
}

function groupLocations(selectOnlyLocationsInAllYears) {
    const selectedYears = store.state.selModel.years.values;
    const locations = store.state.dataLists.allLocations.filter(l => selectedYears.indexOf(l.year) > -1);
    let stateGroups = common.groupBy(locations, 'stateId');

    //Get states that have all years
    if (selectOnlyLocationsInAllYears)
        stateGroups = stateGroups.filter(g => g.length === selectedYears.length);
    const states = stateGroups.map(g => g[0]);
    return states;
}

// function getAllLocationsOld(selectOnlyLocationsInAllYears) {
//     var locations2 = require('@/data/locations.js');
//     console.log('locations2', allLocationsOld, locations2)

//     allLocationsOld.then((res) => console.log('getAllLocationsOld', res));

//     //console.log('@/data/locations')
//   const selectedYears = store.state.selModel.years.values;
//   const locations = allLocationsOld.filter(l => selectedYears.indexOf(l.year) > -1);
//   // console.log('locations', locations.filter(l => l.stateId === 78));

//   let stateGroups = common.groupBy(locations, 'stateId');
//   //Get states that have all years
//   if (selectOnlyLocationsInAllYears)
//     stateGroups = stateGroups.filter(g => g.length === selectedYears.length);
//   const states = stateGroups.map(g => g[0]);
//   return states;
// }

function getAllLocationsForSelection() {
    const selectedYears = store.state.selModel.years.values;
    const locations = store.state.dataLists.allLocations.filter(l => selectedYears.indexOf(l.year) > -1);
    const stateGroups = common.groupBy(locations, 'stateId');
    const states = stateGroups.map(g => ({ location: g[0], isInAllYears: g.length === selectedYears.length }));
    return states;
}

function toTitleList(values) {
    if (values.length === 1)
        return values[0].toString();
    if (values.length === 2)
        return values[0] + ' and ' + values[1];
    if (values.length > 2)
        return values.slice(0, values.length - 1).join(', ') + ' and ' + values[values.length - 1];
    return '';
}

